/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getDataCategories } from 'app/entities/data-category/data-category.reducer';
import { createEntity, getEntity, reset, updateEntity } from './integration-channel.reducer';

export const IntegrationChannelUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const dataCategories = useAppSelector(state => state.dataCategory.entities);
  const integrationChannelEntity = useAppSelector(state => state.integrationChannel.entity);
  const loading = useAppSelector(state => state.integrationChannel.loading);
  const updating = useAppSelector(state => state.integrationChannel.updating);
  const updateSuccess = useAppSelector(state => state.integrationChannel.updateSuccess);

  const handleClose = () => {
    navigate(`/integration-channel${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getDataCategories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...integrationChannelEntity,
      ...values,
      channelType: clinicalDictionaries.find(it => it.id.toString() === values.channelType?.toString()),
      categories: mapIdList(values.categories),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...integrationChannelEntity,
          channelType: integrationChannelEntity?.channelType?.id,
          categories: integrationChannelEntity?.categories?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.integrationChannel.home.createOrEditLabel" data-cy="IntegrationChannelCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.integrationChannel.home.createOrEditLabel">
              Create or edit a IntegrationChannel
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="integration-channel-id"
                  label={translate('tinyMedicRestApp.integrationChannel.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.name')}
                id="integration-channel-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <UncontrolledTooltip target="nameLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.name" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.code')}
                id="integration-channel-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <UncontrolledTooltip target="codeLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.code" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.description')}
                id="integration-channel-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <UncontrolledTooltip target="descriptionLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.description" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.cVersion')}
                id="integration-channel-cVersion"
                name="cVersion"
                data-cy="cVersion"
                type="text"
              />
              <UncontrolledTooltip target="cVersionLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.cVersion" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.active')}
                id="integration-channel-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.cursor')}
                id="integration-channel-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.lastUpdated')}
                id="integration-channel-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.microSec')}
                id="integration-channel-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.timestampEntry')}
                id="integration-channel-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.integrationChannel.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="integration-channel-channelType"
                name="channelType"
                data-cy="channelType"
                label={translate('tinyMedicRestApp.integrationChannel.channelType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationChannel.category')}
                id="integration-channel-category"
                data-cy="category"
                type="select"
                multiple
                name="categories"
              >
                <option value="" key="0" />
                {dataCategories
                  ? dataCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/integration-channel" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntegrationChannelUpdate;
